import {stateData, reduxState} from '../../values';

export const getFaqs = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_faqs,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateFaqs = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_faqs,
            payload:    data,
        })
    }
}